export default __webpack_public_path__ + "static/media/Screenshot_11.090afbc1.png";